module.exports = __webpack_public_path__ + "img/verified_profile_icon.21fea10.png";